<template>
  <div class="class-view">
    <div class="class-view_title">{{ title }}</div>
    <div class="class-view_slot" v-if="$slots.content">
      <slot name="content"></slot>
    </div>
    <Selector-view
      v-else
      :paramKey="paramKey"
      :options="options"
      :columns="columns"
      :multiple="true"
      v-model="_value"
    />
  </div>
</template>

<script>
import { SelectorView } from '@/formily/src'
export default {
  name: 'classView',
  components: {
    SelectorView
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    paramKey: {
      type: String,
      default: ''
    },
    ...SelectorView.props
  },
  computed: {
    _value: {
      get() {
        return this.value
      },
      set(val = []) {
        this.$emit('input', val)
        this.$emit('change', {
          key: this.paramKey,
          value: val
        })
      }
    }
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
.class-view {
  padding: 32px 0;
  &_title {
    font-family: DiDiSans-Pro-Medium;
    font-size: 36px;
    color: #282b33;
    line-height: 44px;
    font-weight: normal;
    margin-bottom: 32px;
  }
}
</style>
